"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const a = ({
  title: e,
  titleId: i,
  desc: d,
  descId: n,
  ...o
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": n,
    ...o,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: n, children: d }) : null,
      e ? /* @__PURE__ */ l("title", { id: i, children: e }) : null,
      /* @__PURE__ */ r("g", { fillRule: "evenodd", clipRule: "evenodd", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M20.6729 2.2008C20.0994 1.1806 19.477.993 18.2097.9216 16.9437.8357 13.7602.8 11.0023.8 8.239.8 5.0543.8357 3.7896.9203c-1.2647.0727-1.8884.259-2.4672 1.2805C.7317 3.2197.4277 4.9746.4277 8.0643v.0105c0 3.0765.304 4.8446.8947 5.8529.5788 1.0202 1.2012 1.2052 2.4659 1.2911 1.266.074 4.4507.1176 7.214.1176 2.7579 0 5.9414-.0436 7.2087-.1163 1.2673-.0859 1.8897-.2709 2.4632-1.2911.596-1.0083.8973-2.7764.8973-5.8528v-.0106c0-3.091-.3013-4.846-.8986-5.8648"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#fff", d: "M8.3574 12.0327v-7.929l6.6075 3.9645z" })
      ] })
    ]
  }
);
export {
  a as default
};
